import script from "./control-compass.vue?vue&type=script&setup=true&lang=ts"
export * from "./control-compass.vue?vue&type=script&setup=true&lang=ts"

import "./control-compass.vue?vue&type=style&index=0&id=bc6f982c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc6f982c"]])

export default __exports__